import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import { observer } from 'mobx-react';

@observer
export class CollapseMenu extends Component {
  render() {
    const { collapse } = this.props;

    return (
      <Collapse isOpen={collapse}>
        <div className="CollapseMenu">{this.props.children}</div>
      </Collapse>
    );
  }
}

export default CollapseMenu;



// WEBPACK FOOTER //
// ./src/components/common/CollapseMenu/index.jsx